/* eslint-disable */
import template from  './vue-template.hbs';
import './index.scss';

const COMPONENT_KEY = 'bfv-matchday';

class BfvMatchday {
  constructor(vue, graphQlConnector) {
    this.vue = vue;
    this.component = null;
    this.eventKey = graphQlConnector.dataLoadedEventKey;
    this.graphQlConnector = graphQlConnector;
    this.componentKey = COMPONENT_KEY; // Just temp
  }

  init() {
    // console.clear();
    // console.log('Matchday: Init');

    this.component = {
      data: () => {
        return {
          queryName: 'currentMatchDay',
          subscriptionName: 'currentMatchDayUpdate',
          componentKey: this.componentKey,
          responseData: {
            matches: []
          },
          errorOccured: false,
          dataLoadedEventKey: this.eventKey,
          wrapperClass: this
        }
      },
      props: [
        'query-attributes',
        'response-attributes',
      ],
      template,
      methods: {
        // websocket setup
        setupGraphqlSubscription: function () {

          const websocketProtokoll = location.protocol === 'http:' ? 'ws' : 'wss';

          this.socket = new WebSocket(`${websocketProtokoll}://${location.host}/subscriptions`, 'graphql-ws');
          this.socket.onopen = () => {
            // console.log('on open');

            const initPayload = {
              type: "connection_init",
              payload: {},
            };
            this.socket.send(JSON.stringify(initPayload));
          };

          this.socket.onmessage = (response) => {
            const data = JSON.parse(response.data);

            // Check if the ws init is working
            if (data.type === 'connection_ack') {
              this.registerSubscription();
            } else if (data.id === this.componentKey) {
              // console.log('matched key');
              this.concactData([data.payload.data.teamAdded])
            }
          };

          this.socket.onclose = () => {
            // console.log('onclose');
          }
        },
        registerSubscription: function () {
          if (this.socket.readyState !== 1) {
            return;
          }

          const subscriptionPayload = {
            id: this.componentKey,
            payload: {
              query: `subscription {${this.subscriptionName} { ${this.queryAttributes} }}`,
              variables: null,
            },
            type: "start",
          };
          this.socket.send(JSON.stringify(subscriptionPayload));
        }
      },
      created: function () {
        let queryAttributes = '';
        if (this.queryAttributes) {
          queryAttributes = `(${this.queryAttributes})`;
        }

        this.query = `${this.queryName + queryAttributes} { ${this.responseAttributes} }`;

        this.wrapperClass.graphQlConnector
          .loadData(`{ ${this.query}  }`)
          .then((response) => {

            console.log("response");
            console.log(response);

            if (response) {
              this.responseData = response[this.queryName];
            } else {
              console.log("HIER");
              this.errorOccured = true;
            }
            //this.setupGraphqlSubscription();
          });
      },
    };

    return this;
  }
}

// For SFC usage
window.bfvSfc = {} || window.bfvSfc;
window.bfvSfc[COMPONENT_KEY] = BfvMatchday;

export default BfvMatchday;



// WEBPACK FOOTER //
// ./src/templates/partials/singleFileComponents/matchday/bfv-matchday.js